export const INDUSTRY_CATEGORIES = {
  FINTECH: 'fintech',
  IT: 'it',
  LID: 'lid'
};
